import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-logo.svg'
import _imports_1 from '../../assets/avatar.jpeg'


const _withScopeId = n => (_pushScopeId("data-v-03aff7f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col items-center justify-between grow h-full bg-sidebarBg border-borderColor z-10" }
const _hoisted_2 = {
  key: 0,
  class: "pt-4 whitespace-nowrap mx-auto mb-10"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "flex justify-center mt-6 flex-wrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-10 h-10 rounded rounded-full bg-white overflow-hidden" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-10 h-10",
      src: _imports_1,
      alt: ""
    })
  ])
], -1))
const _hoisted_6 = {
  key: 0,
  class: "w-full tesx-xs font-semibold text-darkPrimary leading-4 mt-2"
}
const _hoisted_7 = {
  key: 1,
  class: "w-full tesx-xs"
}
const _hoisted_8 = { class: "navigation-container flex justify-between text-textColor w-full mb-4 h-5/9 flex-col overflow-y-scroll" }
const _hoisted_9 = { class: "sidebar-menu" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sidebar-border" }, null, -1))
const _hoisted_12 = { class: "sidebar-content" }
const _hoisted_13 = {
  key: 1,
  class: "sidebar-submenu"
}
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sidebar-border" }, null, -1))
const _hoisted_16 = { class: "sidebar-content" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mt-auto" }, null, -1))
const _hoisted_18 = { class: "mt-auto" }
const _hoisted_19 = { class: "flex flex-wrap items-center px-5 pb-12 text-sm text-menuColor cursor-pointer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.companyTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/orders/all",
            class: "flex justify-center sidebar-company-title"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (_ctx.authorized)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.authorized.first_name) + " " + _toDisplayString(_ctx.authorized.last_name), 1))
              : _createCommentVNode("", true),
            (_ctx.authorized)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.authorized.role.value), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("nav", _hoisted_8, [
      _createElementVNode("ul", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (navItem, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "sidebar-menu__item",
            key: index
          }, [
            (navItem.subMenus)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["sidebar-menu-link", {'router-link-active': _ctx.subIsActive(navItem.routeTo)}]),
                  onClick: ($event: any) => (_ctx.toggleSubMenus(navItem.routeTo))
                }, [
                  _hoisted_11,
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t(navItem.routeText)), 1)
                ], 10, _hoisted_10))
              : _createCommentVNode("", true),
            ((navItem.subMenus && navItem.routeTo === _ctx.selectedRoute) || _ctx.subIsActive(navItem.routeTo))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("ul", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navItem.subMenus, (subNavItem, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: "w-full"
                      }, [
                        _createVNode(_component_router_link, {
                          to: subNavItem.routeTo,
                          class: "text-xs pl-8 text-menuColor justify-start text-start flex flex-wrap items-center pe-2 py-2 sidebar-nav-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(subNavItem.routeText)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (!navItem.subMenus)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  onClick: ($event: any) => (_ctx.toggleSubMenus(index)),
                  to: navItem.routeTo,
                  class: "sidebar-menu-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t(navItem.routeText)), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "to"]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _hoisted_17
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("p", _hoisted_19, [
        _createVNode(_component_BaseIcon, { name: "logout" }),
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
          class: "ms-2"
        }, _toDisplayString(_ctx.$t('auth.logout')), 1)
      ])
    ])
  ]))
}